<div class="form-header">
	<h2 class="ud-heading-xl">Close Account</h2>
	<p>Close your account permanently.</p>
</div>

<div class="um-container" style="margin-bottom:10px">


	<div class="ud-form-group">
		<div *ngIf="message && loginSuccess" class="alert alert-success mb-md-3">
			{{ message}}
		</div>
		<div *ngIf="message_error && !loginSuccess" class="alert alert-danger mb-md-3">
			{{ message_error}}
		</div>
		<p style="color:black"><span style="color:maroon"><strong>Warning:</strong> </span>If you close your account, you will be
			unsubscribed from all journal and books, and will lose access forever.</p>
		<button class="btn btn-primary" (click)="closeAccount()">Close Account</button>
	</div>
</div>